/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <LayoutPrincipal>
    <div class="dashboard">
      <div class="grid-kpis">
        <div class="kpi-card">
          <h2>Total Administradores</h2>
          <p>{{ kpis.totalAdministradores }}</p>
        </div>
        <div class="kpi-card">
          <h2>Total Instaladores</h2>
          <p>{{ kpis.totalInstaladores }}</p>
        </div>
        <div class="kpi-card">
          <h2>Total Clientes</h2>
          <p>{{ kpis.totalClientes }}</p>
        </div>
        <div class="kpi-card kpi-special">
          <h2>Membresía1s activas</h2>
          <p>{{ kpis.membresiasActivas }}</p>
        </div>
        <div class="kpi-card kpi-special">
          <h2>Provedores</h2>
          <p>{{ kpis.proveedores }}</p>
        </div>
        <div class="kpi-card kpi-special">
          <h2>Ferreterías</h2>
          <p>{{ kpis.ferreterias }}</p>
        </div>
      </div>

      <div class="graficas">
        <div class="grafica">
          <h2>Ventas de membresías</h2>
          <BarChart :data="barChartData" />
        </div>
        <div class="grafica">
          <h2>Instaladores por ciudad</h2>
          <PieChart :data="pieChartData" />
        </div>
      </div>

      <div class="graficas-mini">
        <div class="grafica-mini">
          <h3>Ferreterías por ciudad</h3>
          <PieChart :data="ciudadesChartData" />
        </div>
        <div class="grafica-mini">
          <h3>Instaladores por ciudad</h3>
          <PieChart :data="edadChartData" />
        </div>
        <div class="grafica-mini">
          <h3>Proveedores por ciudad</h3>
          <PieChart :data="contratoChartData" />
        </div>
        <div class="grafica-mini">
          <h3>Clientes por ciudad</h3>
          <PieChart :data="ejemploChartData" />
        </div>
      </div>
    </div>
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import BarChart from "../layouts/BarChart.vue";
import PieChart from "../layouts/PieChart.vue";

export default {
  components: {
    LayoutPrincipal,
    BarChart,
    PieChart
  },
  data() {
    return {
      kpis: {
        totalAdministradores: 0,
        totalInstaladores: 0,
        totalClientes: 0,
        membresiasActivas: 0,
        proveedores: 0,
        ferreterias: 0,
      },
      barChartData: {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        datasets: [
          {
            label: "Monto Pagado",
            backgroundColor: "#29b9f6", 
            data: [1200000, 1500000, 1000000, 1800000, 1600000, 2000000],
          },
        ],
      },
      pieChartData: {
        labels: ["Préstamos", "Aguinaldos", "Vacaciones"],
        datasets: [
          {
            backgroundColor: ["#29b9f6", "#888888", "#cccccc"], 
            data: [45, 30, 25],
          },
        ],
      },
      ciudadesChartData: {
        labels: ["Culiacán", "Mazatlán", "Los Mochis", "Guasave"],
        datasets: [
          {
            backgroundColor: ["#29b9f6", "#999999", "#bbbbbb", "#dddddd"], 
            data: [120, 90, 60, 30],
          },
        ],
      },
      edadChartData: {
        labels: ["<30", "30-40", "40-50", "50+"],
        datasets: [
          {
            backgroundColor: ["#29b9f6", "#7f7f7f", "#b0b0b0", "#d0d0d0"], 
            data: [50, 150, 200, 100],
          },
        ],
      },
      contratoChartData: {
        labels: ["Base", "Temporal", "Honorarios"],
        datasets: [
          {
            backgroundColor: ["#29b9f6", "#666666", "#999999"], 
            data: [300, 120, 60],
          },
        ],
      },
      ejemploChartData: {
        labels: ["Ejemplo", "Hola", "Que tal", "Otro"],
        datasets: [
          {
            backgroundColor: ["#29b9f6", "#d0d0d0", "#666666", "#999999"], 
            data: [125, 60, 90, 60],
          },
        ],
      },
    };
  },
  mounted() {
    this.cargarDatosDashboard();
  },
  methods: {
    async cargarDatosDashboard() {
      console.log("Cargando datos del dashboard...");

      const kpisSimulados = await new Promise(resolve => {
        setTimeout(() => {
          resolve({
            admins: 1254,
            instaladores: 2435000, 
            clientes: 1543,
            membresias: 856,
            proveedores: 420,
            ferreterias: 378,
          });
        }, 500); 
      });

      const formatNumber = (num) => num.toLocaleString('es-MX');
      const formatCurrency = (num) => num.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 });

      this.kpis.totalAdministradores = formatNumber(kpisSimulados.admins);
      this.kpis.totalInstaladores = formatCurrency(kpisSimulados.instaladores); 
      this.kpis.totalClientes = formatNumber(kpisSimulados.clientes);
      this.kpis.membresiasActivas = formatNumber(kpisSimulados.membresias);
      this.kpis.proveedores = formatNumber(kpisSimulados.proveedores);
      this.kpis.ferreterias = formatNumber(kpisSimulados.ferreterias);

    }
  }
};
</script>

<style scoped>
.dashboard {
  font-family: Arial, sans-serif;
  color: #333;
}

.grid-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 18px;
  margin-bottom: 20px;
}

.kpi-card {
  background-color: #f5f8fa;
  border-radius: 14px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: default;
  user-select: none;
  position: relative;
  color: #2c3e50;
}

.kpi-card .mini-bar::after {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.477), #29b9f6);

}

.kpi-card:hover {
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}

.kpi-card h2 {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0px;
  min-height: 38px;
  line-height: 1.2;
  font-weight: 600;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}

.kpi-card p {
  font-size: 26px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  text-align: center;
}

.mini-bar {
  --bar-height: 6px;
  width: 100%;
  height: var(--bar-height);
  background-color: #d1d8de;
  border-radius: 4px;
  margin-top: 12px;
  position: relative;
  overflow: hidden;
}

.mini-bar::after {
  content: "";
  display: block;
  height: var(--bar-height);
  width: var(--value);
  background-color: #691c32;
  border-radius: 4px;
  transition: width 0.5s ease;
}

.kpi-special {
  background-color: #f5f8fa;
  color: #1b4f72;
  font-weight: 700;
}

.kpi-special .mini-bar::after {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.477), #29b9f6);
}

.kpi-deuda {
  background-color: #fdecea;
  color: #c0392b;
  font-weight: 700;
}

.kpi-deuda .mini-bar::after {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.477), #29b9f6);
}

.kpi-pagado {
  background-color: #e8f5e9;
  color: #27ae60;
  font-weight: 700;
}

.kpi-pagado .mini-bar::after {
  background: linear-gradient(90deg, #13743b, #2ecc71);
}

.graficas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.grafica {
  box-shadow: 0px 3px 6px #00000029;
  background-color: white;
  padding: 30px 25px;
  border-radius: 16px;
  max-height: 375px;
  overflow: hidden;
}

.grafica h2 {
  margin-top: 0px;
  margin-bottom: 14px;
  font-weight: 700;
  color: #34495e;
}

.graficas-mini {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.grafica-mini {
  box-shadow: 0px 3px 6px #00000029;
  background-color: white;
  padding: 20px 18px;
  border-radius: 14px;
  max-height: 300px;
  overflow: hidden;
}

.grafica-mini h3 {
  margin-top: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  text-align: center;
}

@media (max-width: 900px) {
  .graficas {
    grid-template-columns: 1fr;
  }

  .grid-kpis {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 520px) {
  .grid-kpis {
    grid-template-columns: 1fr;
  }
}
</style>